import Modal from '../Modal';
import { CHANNELS, GROWTH_STATUS_LABELS } from './channelConfig';

export default function CampaignDetailModal({ isOpen, onClose, campaign, stats, loading }) {
  if (!isOpen) return null;

  const st = campaign
    ? GROWTH_STATUS_LABELS[campaign.status] || GROWTH_STATUS_LABELS.DRAFT
    : null;
  const hasInApp = (campaign?.channels || []).includes('IN_APP');

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Détail campagne" maxWidth="max-w-2xl">
      <div className="px-6 py-5">
        {loading && <p className="text-sm text-gray-500">Chargement…</p>}
        {!loading && !campaign && (
          <p className="text-sm text-gray-500">Campagne introuvable.</p>
        )}
        {!loading && campaign && (
          <div className="space-y-4">
            <div className="flex flex-wrap items-center gap-2">
              <h4 className="text-lg font-semibold text-gray-900">
                {campaign.title || campaign.subject}
              </h4>
              <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${st.badge}`}>
                {st.label}
              </span>
              {campaign.kind === 'TEST' && (
                <span className="text-xs text-amber-700 bg-amber-50 px-2 py-0.5 rounded">Test</span>
              )}
            </div>

            {stats && (
              <div className="rounded-lg border border-gray-100 bg-gray-50 p-4 space-y-3">
                <p className="text-xs font-medium text-gray-500 uppercase">Performance</p>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
                  <div>
                    <p className="text-gray-500">Clients contactés</p>
                    <p className="font-medium">{stats.clientsContacted ?? 0}</p>
                  </div>
                  {hasInApp && stats.inApp && (
                    <>
                      <div>
                        <p className="text-gray-500">Lectures In-App</p>
                        <p className="font-medium text-emerald-700">
                          {stats.inApp.read ?? 0}
                          {stats.inApp.readRatePct != null && (
                            <span className="text-gray-500 font-normal ml-1">
                              ({stats.inApp.readRatePct} %)
                            </span>
                          )}
                        </p>
                      </div>
                      <div>
                        <p className="text-gray-500">Messages In-App envoyés</p>
                        <p className="font-medium">{stats.inApp.sent ?? 0}</p>
                      </div>
                    </>
                  )}
                  {stats.email && (stats.email.dispatched > 0 || !hasInApp) && (
                    <div>
                      <p className="text-gray-500">Emails expédiés</p>
                      <p className="font-medium">{stats.email.dispatched ?? 0}</p>
                      <p className="text-xs text-gray-400 mt-0.5">Lecture email non mesurée (V1)</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
              <div>
                <p className="text-gray-500">Destinataires</p>
                <p className="font-medium">{campaign.recipientCount ?? 0}</p>
              </div>
              <div>
                <p className="text-gray-500">Succès</p>
                <p className="font-medium text-emerald-700">{campaign.sentCount ?? 0}</p>
              </div>
              <div>
                <p className="text-gray-500">Échecs</p>
                <p className="font-medium text-red-600">{campaign.failedCount ?? 0}</p>
              </div>
              <div>
                <p className="text-gray-500">Quota consommé</p>
                <p className="font-medium text-sm">
                  {[
                    campaign.emailQuotaConsumed ? 'Email' : null,
                    campaign.inAppQuotaConsumed ? 'In-App' : null,
                  ]
                    .filter(Boolean)
                    .join(' + ') || 'Non consommé'}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-1">
              {(campaign.channels || []).map((c) => (
                <span key={c} className="px-2 py-0.5 rounded bg-gray-100 text-gray-700 text-xs">
                  {CHANNELS.find((x) => x.id === c)?.label || c}
                </span>
              ))}
            </div>

            {campaign.subject && (
              <div>
                <p className="text-xs text-gray-500 uppercase">Sujet</p>
                <p className="text-sm text-gray-800">{campaign.subject}</p>
              </div>
            )}

            {campaign.textContent && (
              <div>
                <p className="text-xs text-gray-500 uppercase mb-1">Message</p>
                <pre className="text-sm text-gray-800 whitespace-pre-wrap bg-gray-50 rounded-md p-3 border border-gray-100 font-sans">
                  {campaign.textContent}
                </pre>
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}
